import React, { useEffect, useRef } from 'react';
import ReactDom from 'react-dom';
import { Link } from 'react-router-dom';

import { usePromoCodes } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

import { NavNotchSpacer } from 'components/Layout/notchSpacer';
import { defaultRoutes } from 'components/MainRouter/constants';
import PromoCodesApply from 'src/components/PromoCodes/PromoCodesApply';
import PromoCodesList from 'src/components/PromoCodes/PromoCodesList';

import ShortFooter from '../Footer/ShortFooter';

const { account } = defaultRoutes;

const PromoCodes = () => {
  const scrollRef = useRef();
  const { changeCurrentPage, getPromoCodes, loading, paging, promoCodes } = usePromoCodes();

  useEffect(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }
  }, [promoCodes]);

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={account}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message="promocodes" />
      </Link>

      <PromoCodesApply
        changeCurrentPage={changeCurrentPage}
        getPromoCodes={getPromoCodes}
        paging={paging}
      />

      <div className="promo-codes-list__wrapper" ref={scrollRef}>
        <PromoCodesList
          changeCurrentPage={changeCurrentPage}
          loading={loading}
          paging={paging}
          promoCodes={promoCodes}
        />
        <ShortFooter />
        <NavNotchSpacer />
      </div>
    </div>,
    document.body,
  );
};

export default PromoCodes;
